<template active-class="ColumnContainer">
  <div class="ColumnContainer">
    <common ref="common" />
    <div class="FixedItem">
      <div class="srchcol-12">
        <v-card class="mx-auto rounded-lg" elevation="24" max-width="95%">
          <v-text-field
            placeholder="Search..."
            v-model="filterModel.filter"
            outlined
            hide-details
            dense
            size="medium"
            append-icon="mdi-magnify"
            @click:append="filter()"
            @keyup.native="filter()"
            @mousedown="clearContains()"
          >
          </v-text-field>
        </v-card>
      </div>
    </div>

    <!-- <v-row> -->
    <div class="ColumnContainer">
      <!-- <div class="ScrollContainer"> -->
      <!-- <v-col cols="12"> -->
      <v-container class="bg-surface-variant">
        <v-row>
          <v-col
            cols="12"
            xs="6"
            sm="6"
            v-for="(member, index) in membersList"
            :key="index"
          >
            <v-card
              class="mx-auto rounded-xl mb-2 mt-2"
              elevation="24"
              max-width="100%"
            >
              <v-row>
                <v-col
                  cols="4"
                  @click="showdetails(member)"
                  class="text-center"
                >
                  <v-avatar v-if="member.storedUrl" size="86px">
                    <img :src="$url + member.storedUrl" />
                  </v-avatar>
                  <v-avatar v-else size="86px">
                    <img src="../../assets/dummy-profile-image.png" />
                  </v-avatar>
                </v-col>
                <v-col cols="8" class="mx-auto">
                  <a
                    :href="`tel:${member.mobileNumber}`"
                    style="color: white; text-decoration: none"
                  >
                    <v-row cols="12" class="mem-display-vrow-style pt-3 mt-1">
                      <div
                        v-if="
                          member.salutation !== null &&
                          member.salutation.indexOf('.') > -1
                        "
                      >
                        {{ member.salutation }} {{ member.name }}
                      </div>
                      <div
                        v-else-if="
                          member.salutation !== null &&
                          member.salutation.indexOf('.') === -1
                        "
                      >
                        {{ member.salutation }}.{{ member.name }}
                      </div>
                      <div v-else>{{ member.name }}</div>
                    </v-row>

                    <v-row cols="12" class="mem-display-vrow-style pt-1">
                      <div
                        v-if="
                          member.mobileNumber !== null &&
                          member.mobileNumber !== ''
                        "
                        icon
                        mini
                      >
                        <v-icon class="mem-display-icon-style"
                          >mdi-phone-forward</v-icon
                        >
                      </div>
                      {{ member.mobileNumber }}
                    </v-row>
                  </a>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-card-actions v-if="totalPages > filterModel.page" class="center">
      <v-btn
        small
        class="mx-auto ma-5"
        color="success"
        @click="loadMore"
        fixed
        center
        bottom
        >Load More</v-btn
      >
    </v-card-actions>

    <v-dialog
      transition="dialog-top-transition"
      fullscreen
      v-model="memberDetailDialog"
      @keydown.esc="memberDetailDialog = false"
    >
      <memberCard
        v-if="memberDetailDialog"
        :memberId.sync="memberId"
        :propdialog.sync="memberDetailDialog"
      />
    </v-dialog>
  </div>
</template>
<script>
import common from "@/components/tools/common";
import { callApi } from "@/api/others";
import memberCard from "./components/memberCard";
import dayjs from "dayjs";
export default {
  components: { common, memberCard },
  data() {
    return {
      show: false,
      skeletonLoaderType: "list-item-avatar-three-line",
      // skeletonLoaderType:"article",
      membersList: [],
      filterModel: {
        sort: "name",
        page: 1,
        per_page: 10,
        filter: "",
        id: 0,
        param: "",
        where: null,
        downloadFile: false,
        filterData: "",
      },
      totalPages: 0,
      memberDetailDialog: false,
      memberId: "",
    };
  },
  mounted() {
    this.$emit("setBottomNav", 2);
    this.getMemberList();
  },
  watch: {
    "filterModel.filter": function (newv, oldv) {
      if (newv != oldv && newv === "") {
        this.filter();
      }
    },
  },
  methods: {
    getDetails() {
      this.show = !this.show;
      var common = this.$refs.common;
      if (this.id) {
        var url = "/api/wesupport/Member/getbyidminified";
        var Data = {
          id: this.id,
        };
        // console.log(Data);
        callApi(url, "post", Data)
          .then((response) => {
            this.member = response.data.data;
            this.member.joinDate = new Date(this.member.joinDate);
            if (
              this.member.ledger.person.dateOfBirth !== null &&
              this.member.ledger.person.dateOfBirth !== "" &&
              this.member.ledger.person.dateOfBirth !== undefined
            ) {
              this.member.ledger.person.dateOfBirth = new Date(
                this.member.ledger.person.dateOfBirth
              );
            }
          })
          .catch((error) => {
            common.ManageResponse(error);
          });
      }
    },
    DateFormat(d) {
      return dayjs(d).format("DD-MM-YYYY");
    },
    clearContains() {
      this.filterModel.filter = "";
    },
    showdetails(member) {
      this.memberId = member.id;
      this.memberDetailDialog = true;
    },
    filter() {
      this.membersList = [];
      this.filterModel.page = 1;
      this.getMemberList();
    },
    loadMore() {
      this.$emit("loadingChange", true);
      this.filterModel.page += 1;
      this.getMemberList();
      this.$emit("loadingChange", false);
    },
    getMemberList() {
      var common = this.$refs.common;
      var url = "/api/wesupport/Member/GetDirectory?filterSts=true";
      callApi(url, "post", this.filterModel)
        .then((response) => {
          var result = response.data;
          console.log(result);
          var items = result.items;
          this.membersList.push(...items);
          items.forEach((element) => {
            if (
              element.storedUrl !== null &&
              element.storedUrl !== "" &&
              element.storedUrl !== undefined
            ) {
              element.storedUrl = element.storedUrl.replace(
                "UserUploads",
                "UserUploads/Thump"
              );
            }
          });
          this.totalPages = result.totalPages;
          this.filterModel.page = result.page;
          console.log(this.membersList);
        })
        .catch((error) => {
          common.ManageResponse(error.response);
        });
    },
  },
};
</script>
<style>
</style>
